import { CHART_EDITED, Mixpanel } from 'libs/third-party/Mixpanel';
import {
  ChartSettingsDivider,
  SettingsAccordion,
  Switcher,
} from 'modules/Editor/components/SideMenuSettings/ChartSettings';
import { useTranslation } from 'react-i18next';
import { WidgetType } from 'types/widget.types';
import { getChartInfo } from 'widgets/ChartWidgets/ChartWidget.helpers';
import { ChartWidgetData } from 'widgets/ChartWidgets/ChartWidget.types';
import { useWidget } from 'widgets/sdk';

import { DataLabelFont, DataLabelText } from './ChartSettingsLabel';

interface ChartSettingsLabelCloudBubbleProps {
  widgetType: WidgetType;
}

export const ChartSettingsLabelCloudBubble = ({ widgetType }: ChartSettingsLabelCloudBubbleProps) => {
  const {
    dataLabels: { categoryEnabled, valueEnabled, enabled },
    updateWidget,
  } = useWidget<ChartWidgetData>();
  const { t } = useTranslation('chart_widget', { useSuspense: false });

  // if the categoryEnabled or valueEnabled is not defined, use the enabled value (can be the case for old widgets)
  const isValueEnabled = typeof valueEnabled === 'undefined' ? enabled : valueEnabled;
  const isCategoryEnabled = typeof categoryEnabled === 'undefined' ? enabled : categoryEnabled;

  const onToggleCategoryLabel = () => {
    updateWidget({ dataLabels: { categoryEnabled: !isCategoryEnabled } });
    Mixpanel.track(CHART_EDITED, {
      styling_property: CHART_EDITED.styling_property.Labels,
      styling_value: !categoryEnabled
        ? CHART_EDITED.styling_value.CategoryLabelsOn
        : CHART_EDITED.styling_value.CategoryLabelsOff,
      chart_type: getChartInfo(widgetType).widgetTypeName,
    });
  };

  const onToggleValueLabel = () => {
    updateWidget({ dataLabels: { valueEnabled: !isValueEnabled } });
    Mixpanel.track(CHART_EDITED, {
      styling_property: CHART_EDITED.styling_property.Labels,
      styling_value: !valueEnabled
        ? CHART_EDITED.styling_value.ValueLabelsOn
        : CHART_EDITED.styling_value.ValueLabelsOff,
      chart_type: getChartInfo(widgetType).widgetTypeName,
    });
  };

  return (
    <SettingsAccordion title={t('labels.label')} isDefaultOpen={true}>
      <Switcher label={t('labels.showCategories')} onToggle={onToggleCategoryLabel} isChecked={isCategoryEnabled} />
      <Switcher
        label={t('labels.showValue')}
        onToggle={onToggleValueLabel}
        isChecked={isValueEnabled}
        style={{ marginTop: 0 }}
      />
      <ChartSettingsDivider />
      <DataLabelFont />
      <DataLabelText showFontColor />
    </SettingsAccordion>
  );
};
